<script lang="ts">
  import { toast } from '../lib/state';
</script>

{#if $toast}
  <div class="map-toast" role="status" aria-live="polite">{$toast}</div>
{/if}
